var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticStyle:{"height":"100%","margin-bottom":"0"},attrs:{"gutter":20,"type":"flex"}},[_c('el-col',{staticStyle:{"height":"100%"},attrs:{"lg":7,"md":9}},[_c('ChatSessionSummary',{on:{"refreshSummary":_vm.refreshSummary}})],1),_c('el-col',{staticStyle:{"height":"100%"},attrs:{"lg":17,"md":15}},[_c('AgentSessionDetails')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }